import React, { createContext, useContext, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDataApi } from './DataApiContext'
import { useNotificationsProvider } from './NotificationsContext'
import DocumentImportNotificationService from '../services/DocumentImportNotificationService'

const DocumentImportNotificationContext = createContext(null)

export function DocumentImportNotificationProvider({ children }) {
  const { t } = useTranslation()
  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  // Initialize service immediately on first render (not in useEffect)
  const serviceRef = useRef(null)
  if (!serviceRef.current) {
    console.log('[DocumentImportNotificationContext] Creating service instance')
    serviceRef.current = new DocumentImportNotificationService(
      dataProvider,
      { showNotification },
      t
    )
    serviceRef.current.initialize()
  }

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      console.log(
        '[DocumentImportNotificationContext] Provider unmounting, cleaning up service'
      )
      if (serviceRef.current) {
        serviceRef.current.cleanup()
      }
    }
  }, [])

  return (
    <DocumentImportNotificationContext.Provider value={serviceRef.current}>
      {children}
    </DocumentImportNotificationContext.Provider>
  )
}

export function useDocumentImportNotification() {
  const context = useContext(DocumentImportNotificationContext)
  // Note: context might be null on first render before service initializes
  // This is OK - components should handle null gracefully
  return context
}
